import { CSSProperties } from "react";
import { Modal, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles";

export interface SimpleModalProps {
  isOpen: boolean;
  handleClose: any;
  children: React.ReactNode;
  externalStyles?: CSSProperties;
}

export const SimpleModal = ({
  isOpen,
  handleClose,
  children,
  externalStyles = {},
}: SimpleModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={styles.modalContainer}
    >
      <Box sx={{ ...styles.modalStyle, ...externalStyles }}>
        <CloseIcon sx={styles.closeButton} onClick={handleClose} />
        {children}
      </Box>
    </Modal>
  );
};

export default SimpleModal;
